import "./topPicContent.scss";
import Vue from "vue";

const profileUrl = require("@/assets/icons-file/dialog/pic_popup_profileinfoincomplete.png");
const loginRequiredUrl = require("@/assets/icons-file/dialog/pic_popup_loginrequired@3x.png");

export default function topIconComponent(pic: string, type: string = "circle") {
  const El = Vue.extend({
    template: `
        <div class="top-pic" :class="[type]">
          <div class="top-pic-inner">
              <img :src="pic" class="user-pic">
          </div>
          <img 
          :src="profileUrl" 
          v-show="type=='profile'"
          class="profile-pic"/>
          <img 
          :src="loginRequiredUrl" 
          v-show="type=='loginRequired'"
          class="profile-pic"/>
        </div>`,
    computed: {
      pic() {
        return pic;
      },
      profileUrl() {
        return profileUrl;
      },
      loginRequiredUrl() {
        return loginRequiredUrl;
      },
      type() {
        return type;
      }
    }
  });
  return new El();
}
